import { ROUTES } from "@/core/router/routes";

export const getLink = (path: string) => {
  return `/${path}`;
};

export const getDashboardLink = (path: string) => {
  return `/${ROUTES.Dashboard.Root}/${path}`;
};

export const getDashboardRoute = () => {
  return `/${ROUTES.Dashboard.Root}`;
};
